import { Breadcrumb, Button, Col, Row, Typography } from 'antd';
import { StyleSheet } from "../StyleSheet";
import useBreadcrumbs, { BreadcrumbsRoute } from "use-react-router-breadcrumbs";
import { NavLink, useNavigate } from 'react-router-dom';
import { routes } from "../routes/Routes"
import { Content } from 'antd/es/layout/layout';
import { ReactNode } from 'react';
import { LeftOutlined } from '@ant-design/icons';

const { Text } = Typography;

type SubDefaultLayoutProps = {
    children: ReactNode;
    title: string;
    subtitle?: string;
    needReturn?: boolean;
    navigateTo?: string;
    functionReturn?: Function;
    customBreadcrumb?: string;
    customBreadcrumbTo?: string;
}

const SubDefaultLayout = (props: SubDefaultLayoutProps) => {
    const { title, subtitle, needReturn, navigateTo, functionReturn, customBreadcrumb, customBreadcrumbTo } = props;
    const navigate = useNavigate();

    const breadcrumbRoutes: BreadcrumbsRoute<string>[] = routes.map((route) => ({
        path: route.path,
        breadcrumb: route.breadcrumb,
    }));

    const HomeBreadcrumb: BreadcrumbsRoute<string> = { path: "/", breadcrumb: "" };

    const filteredBreadcrumbs = useBreadcrumbs([...breadcrumbRoutes, HomeBreadcrumb], {
        excludePaths: ["/"],
    });

    const goBack = () => {
        if (navigateTo) {
            navigate(navigateTo);
        }
    };

    return (
        <Row style={styles.rowRoot}>
            <Col span={18} style={styles.divRoot}>
                <Content style={styles.headerContent}>
                    <Row
                        style={{
                            width: "100%",
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <Col xs={24} xl={24} style={styles.mainDiv}>
                            <Breadcrumb>
                                {(customBreadcrumb && customBreadcrumbTo) ? (
                                    <Breadcrumb.Item>
                                        <NavLink
                                            to={customBreadcrumbTo}
                                            style={styles.breadcrumbStyle}
                                        >
                                            {customBreadcrumb}
                                        </NavLink>
                                    </Breadcrumb.Item>
                                ) : (
                                    filteredBreadcrumbs.map(({ match, breadcrumb }) => (
                                        <Breadcrumb.Item key={match.pathname}>
                                            <NavLink
                                                key={match.pathname}
                                                to={match.pathname}
                                                style={styles.breadcrumbStyle}
                                            >
                                                {breadcrumb}
                                            </NavLink>
                                        </Breadcrumb.Item>
                                    ))
                                )}
                            </Breadcrumb>
                        </Col>
                    </Row>
                    <Row
                        style={{
                            width: "100%",
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <Col xs={6} xl={6} style={{ ...styles.titleRow }}>
                            {needReturn === true ? (

                                <Button style={styles.buttonPrimary} type="primary"
                                    onClick={() => functionReturn ? functionReturn() : goBack()}>
                                    <LeftOutlined />
                                    {"Regresar"}
                                </Button>
                            ) : null}
                        </Col>
                        <Col xs={12} xl={12} style={{ ...styles.titleRow, justifyContent: 'center' }}>
                            <Text style={styles.textTitle}>
                                {title}
                                {
                                    subtitle ? (
                                        <Text style={styles.subtitle}>
                                            {subtitle}
                                        </Text>
                                    ) : null
                                }
                            </Text>
                        </Col>
                        <Col xs={6} xl={6} style={{ ...styles.titleRow }}>
                        </Col>
                    </Row>
                    <Content style={styles.contentView}>
                        {props.children}
                    </Content>
                </Content>
            </Col>
        </Row>
    );
};

const styles = StyleSheet.create({
    rowRoot: {
        width: "100%",
        height: "100%",
        justifyContent: "center",
    },
    divRoot: {
        display: "flex",
        flexDirection: "column",
        width: "80%",
    },
    headerContent: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
    },
    mainDiv: {
        display: 'flex',
        flexDirection: 'column',
        width: '80%',
        marginTop: 20,
    },
    contentView: {
        marginTop: 20,
        width: "100%",
        height: "100%",
    },
    textTitle: {
        fontFamily: "Montserrat",
        fontSize: "2.9375em",
        fontWeight: 500,
        color: "#0055b9",
        textAlign: "center",
        lineHeight: 1.02
    },
    subtitle: {
        fontSize: 14,
        fontWeight: "normal",
        color: "#a4a4a4",
        marginLeft: 10
    },
    buttonPrimary: {
        backgroundColor: '#00339e',
        borderRadius: 30,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        padding: "20px 20px",
        fontSize: 16
    },
    titleRow: {
        justifyContent: 'flex-start',
        display: 'flex',
        alignItems: 'flex-start',
        marginTop: 20
    },
    breadcrumbStyle: {
        color: '#0055ba',
        fontWeight: 600
    }
});

export default SubDefaultLayout;
